import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BriefcaseManager } from '@managers/briefcase.manager';
import { LexbeDoc } from '@models/doc.model';
import { BriefcaseJob } from '@models/review/briefcase-job.model';
import { Role } from '@models/role.model';
import { UserConfigsService } from '@services/user-configs.service';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-export-document-panel',
    templateUrl: './export-document-panel.component.html',
    styleUrls: ['./export-document-panel.component.scss'],
    standalone: false
})
export class ExportDocumentPanelComponent extends BaseComponent {

  public currentDocumentSnapshot: LexbeDoc;
  public briefcase: BriefcaseJob = { title: `Briefcase ${new Date().toLocaleDateString()}` };
  get Role(): typeof Role { return Role; }

  constructor(public userConfigService: UserConfigsService,
    private briefcaseManager: BriefcaseManager,
    private docViewerStore: DocViewerStore,
    private route: ActivatedRoute,
    private router: Router) {
    super();
    this.briefcase.expandToEmailFamily = false;
    this.docViewerStore.currentDocument$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((snapshot) => {
      this.currentDocumentSnapshot = snapshot;
    });
  }

  ok() {
    if (!this.briefcase) {
      return;
    }
    this.briefcase.briefcaseJobDocIds = [this.currentDocumentSnapshot.docId];
    this.briefcase.caseId = this.currentDocumentSnapshot.caseId;

    this.briefcaseManager.createBriefcase(this.briefcase).subscribe(() => {
      this.router.navigate(["."], {
        queryParams: {
          action: null
        },
        queryParamsHandling: "merge",
        relativeTo: this.route
      });
    });
  }
}
